import styled, { css, keyframes } from 'styled-components';

import TertiaryButton from 'components/v2/Button/TertiaryButton';
import { COLORS } from 'theme';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const StyledRefreshButton = styled(TertiaryButton)`
  &&& {
    padding: 9px;
    border: 1px solid ${COLORS.black10};
    svg {
      width: ${({ theme }) => theme.spacing.s4};
      height: ${({ theme }) => theme.spacing.s4};
      path {
        fill: ${COLORS.black50};
      }
    }

    &:hover {
      background-color: ${`${COLORS.black30}1A`};
      border: 1px solid ${`${COLORS.black30}1A`};
    }

    ${({ $isLoading }) =>
      $isLoading &&
      css`
        svg {
          animation: ${spin} 1s linear infinite;
        }
      `}
  }
`;
